import React from "react";
import {
  FaBookOpen,
  FaBullhorn,
  FaChild,
  FaDatabase,
  FaEnvelope,
  FaInfoCircle,
  FaLock,
  FaShieldAlt,
  FaSyncAlt,
  FaUserCog,
} from "react-icons/fa";
import "./PrivacyPolicy.css";

const SUPPORT_EMAIL = "kugathaj@gmail.com";

const PrivacyPolicy: React.FC = () => {
  return (
    <main className="privacy-page">
      <section className="privacy-container">
        <header className="privacy-header-card">
          <p className="privacy-kicker">
            <FaShieldAlt />
            <span>Datenschutzerklärung</span>
          </p>

          <h1 className="privacy-page-title">
            Datenschutzerklärung für DEUTSCH A1-C2
          </h1>

          <p className="privacy-subtitle">
            Diese Datenschutzerklärung erklärt, wie Daten bei der Nutzung der
            DEUTSCH A1-C2 App verarbeitet werden können.
          </p>
        </header>

        <div className="privacy-learning-grid">
          <article className="privacy-group">
            <div className="privacy-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="privacy-card-left">
              <div className="privacy-level-block">
                <span className="privacy-level-icon">
                  <FaShieldAlt />
                </span>

                <span className="privacy-status">Datenschutz</span>
              </div>

              <div className="privacy-title-block">
                <h2>Schutz</h2>
                <p>Daten</p>
                <small>Privatsphäre</small>
              </div>
            </section>

            <section className="privacy-card-right">
              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaInfoCircle />
                  </span>
                  <h2>Einführung</h2>
                </div>

                <p>
                  DEUTSCH A1-C2 („wir“, „uns“ oder „unser“) verpflichtet sich,
                  Ihre Privatsphäre zu schützen. Diese Datenschutzerklärung
                  erklärt, wie Informationen verarbeitet werden können, wenn Sie
                  die DEUTSCH A1-C2 App („App“) nutzen.
                </p>
              </div>

              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaDatabase />
                  </span>
                  <h2>1. Welche Informationen wir verarbeiten</h2>
                </div>

                <p>
                  Für die grundlegenden Lernfunktionen der App müssen Sie nicht
                  zwingend ein Konto erstellen. Wir fragen Sie in der App nicht
                  direkt nach persönlichen Daten wie Name, Postadresse oder
                  Telefonnummer, um die Kernfunktionen zu nutzen.
                </p>

                <p>
                  Die App nutzt jedoch Dienste von Drittanbietern für
                  Abonnements, Käufe und Werbung. Diese Dienste können bestimmte
                  Daten automatisch verarbeiten, damit ihre Funktionen korrekt
                  bereitgestellt werden.
                </p>
              </div>
            </section>
          </article>

          <article className="privacy-group">
            <div className="privacy-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="privacy-card-left">
              <div className="privacy-level-block">
                <span className="privacy-level-icon">
                  <FaLock />
                </span>

                <span className="privacy-status">Dienste</span>
              </div>

              <div className="privacy-title-block">
                <h2>Partner</h2>
                <p>Drittanbieter</p>
                <small>Systeme</small>
              </div>
            </section>

            <section className="privacy-card-right">
              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaLock />
                  </span>
                  <h2>2. Dienste von Drittanbietern</h2>
                </div>

                <p>Die App kann Dienste von Drittanbietern nutzen, zum Beispiel:</p>

                <p className="privacy-list-text">
                  • Apple App Store / StoreKit für iOS-Abonnements und Käufe
                  <br />
                  • Google Play Billing für Android-Abonnements und Käufe
                  <br />
                  • RevenueCat für Abo-Verwaltung und Kaufstatus
                  <br />• Drittanbieter für Werbung bei kostenlosen Nutzern
                </p>

                <p>
                  Diese Dienste können je nach Plattform, Region und verwendetem
                  Dienst Informationen wie Geräteinformationen, App-Version,
                  Kaufstatus, Kennungen, IP-Adresse, ungefähren Standort,
                  Diagnosedaten und werbebezogene Daten verarbeiten.
                </p>
              </div>

              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaUserCog />
                  </span>
                  <h2>3. Wie Informationen genutzt werden</h2>
                </div>

                <p>
                  Informationen, die durch die App oder durch Dienstanbieter
                  verarbeitet werden, können für folgende Zwecke genutzt werden:
                </p>

                <p className="privacy-list-text">
                  • Premium-Zugang bereitstellen und wiederherstellen
                  <br />
                  • Abonnements und Käufe verarbeiten
                  <br />
                  • Werbung für kostenlose Nutzer anzeigen
                  <br />
                  • Betrug und Missbrauch verhindern
                  <br />• Sicherheit, Funktionalität und Zuverlässigkeit
                  erhalten
                </p>
              </div>
            </section>
          </article>

          <article className="privacy-group">
            <div className="privacy-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="privacy-card-left">
              <div className="privacy-level-block">
                <span className="privacy-level-icon">
                  <FaBullhorn />
                </span>

                <span className="privacy-status">Werbung</span>
              </div>

              <div className="privacy-title-block">
                <h2>Nutzung</h2>
                <p>Werbung</p>
                <small>Optionen</small>
              </div>
            </section>

            <section className="privacy-card-right">
              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaBullhorn />
                  </span>
                  <h2>4. Werbung</h2>
                </div>

                <p>
                  Kostenlose Nutzer können Werbung in der App sehen. Werbung
                  kann von Drittanbieter-Werbenetzwerken bereitgestellt werden.
                  Diese Anbieter können Daten verarbeiten, die erforderlich sind,
                  um Werbung bereitzustellen, zu messen und zu verbessern. Dies
                  erfolgt gemäß den jeweiligen Datenschutzerklärungen und den
                  geltenden Gesetzen.
                </p>
              </div>

              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaDatabase />
                  </span>
                  <h2>5. Datenspeicherung</h2>
                </div>

                <p>
                  Wir führen innerhalb der App keine klassischen Nutzerprofile.
                  Drittanbieter, die für Abonnements, Zahlungen, Diagnosen oder
                  Werbung eingesetzt werden, können Daten jedoch so lange
                  speichern, wie es zur Bereitstellung ihrer Dienste, zur
                  Erfüllung gesetzlicher Pflichten, zur Streitbeilegung oder zur
                  Durchsetzung ihrer Vereinbarungen erforderlich ist.
                </p>
              </div>

              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaBookOpen />
                  </span>
                  <h2>6. Ihre Wahlmöglichkeiten</h2>
                </div>

                <p>
                  Abo-Verwaltung, Kündigung und Abrechnung erfolgen über die
                  Plattform, über die Sie das Abonnement abgeschlossen haben, zum
                  Beispiel Apple App Store oder Google Play. Je nach Gerät,
                  Plattform und Region können Ihnen außerdem Optionen zu
                  personalisierter Werbung oder Tracking-Berechtigungen
                  angeboten werden.
                </p>
              </div>
            </section>
          </article>

          <article className="privacy-group">
            <div className="privacy-card-particles" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            <section className="privacy-card-left">
              <div className="privacy-level-block">
                <span className="privacy-level-icon">
                  <FaChild />
                </span>

                <span className="privacy-status">Hinweis</span>
              </div>

              <div className="privacy-title-block">
                <h2>Rechte</h2>
                <p>Kontakt</p>
                <small>Support</small>
              </div>
            </section>

            <section className="privacy-card-right">
              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaChild />
                  </span>
                  <h2>7. Datenschutz von Kindern</h2>
                </div>

                <p>
                  Die App richtet sich an ein allgemeines Publikum. Wir sammeln
                  nicht wissentlich persönliche Daten direkt von Kindern über
                  Kontoerstellung oder ähnliche Funktionen. Wenn Sie glauben,
                  dass uns personenbezogene Daten unangemessen übermittelt
                  wurden, kontaktieren Sie uns bitte.
                </p>
              </div>

              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaSyncAlt />
                  </span>
                  <h2>8. Änderungen dieser Datenschutzerklärung</h2>
                </div>

                <p>
                  Wir können diese Datenschutzerklärung von Zeit zu Zeit
                  aktualisieren. Wenn wir Änderungen vornehmen, veröffentlichen
                  wir die aktualisierte Version auf dieser Seite. Wenn Sie die
                  App nach Inkrafttreten der Änderungen weiter nutzen, stimmen
                  Sie der aktualisierten Datenschutzerklärung zu.
                </p>
              </div>

              <div className="privacy-section">
                <div className="privacy-section-title">
                  <span className="privacy-section-icon">
                    <FaEnvelope />
                  </span>
                  <h2>9. Kontakt</h2>
                </div>

                <p>
                  Wenn Sie Fragen zu dieser Datenschutzerklärung haben,
                  kontaktieren Sie uns bitte unter{" "}
                  <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
                </p>
              </div>
            </section>
          </article>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;